/*
 * @Author: wzh
 * @Date: 2023-07-31 11:17:09
 * @LastEditTime: 2023-07-31 11:57:02
 * @Description: 错误提示页面路由
 */
import { NotFound } from "@/views/error/index";

export default [
  {
    name: "NotFound", // 404
    path: "*",
    component: NotFound,
  },
];
